import { customFetch } from "@/client/custom-fetch";

import {
  TCampaignAnalyticsSummary,
  TCampaignContact,
  TCampaignDetails,
  TCampaignDispatchRunRow,
} from "./campaign-details.types";

export const getCampaignDetailsById = async (
  campaignId: string
): Promise<TCampaignDetails> => {
  return customFetch<TCampaignDetails>(`/campaigns/${campaignId}`);
};

export const getCampaignContactsByCampaignId = async (
  campaignId: string
): Promise<TCampaignContact[]> => {
  return customFetch<TCampaignContact[]>(`/campaigns/${campaignId}/contacts`);
};

export const getCampaignAnalyticsSummary = async (
  campaignId: string,
  params?: { from?: string; to?: string }
): Promise<TCampaignAnalyticsSummary> => {
  const qs = new URLSearchParams();
  if (params?.from) {
    qs.set("from", params.from);
  }
  if (params?.to) {
    qs.set("to", params.to);
  }
  const q = qs.toString();
  return customFetch<TCampaignAnalyticsSummary>(
    `/campaigns/${campaignId}/analytics/summary${q ? `?${q}` : ""}`
  );
};

export const getCampaignDispatchRuns = async (
  campaignId: string,
  params?: { from?: string; to?: string }
): Promise<TCampaignDispatchRunRow[]> => {
  const qs = new URLSearchParams();
  if (params?.from) {
    qs.set("from", params.from);
  }
  if (params?.to) {
    qs.set("to", params.to);
  }
  const q = qs.toString();
  return customFetch<TCampaignDispatchRunRow[]>(
    `/campaigns/${campaignId}/whatsapp/dispatch-runs${q ? `?${q}` : ""}`
  );
};

export type TEnrichCampaignContactsResponse = {
  processed: number;
  failed: number;
  errors: Array<{ contact_id: string; reason: string }>;
};

export const enrichCampaignContacts = async (
  campaignId: string,
  body?: { contact_ids?: string[] }
): Promise<TEnrichCampaignContactsResponse> => {
  return customFetch<TEnrichCampaignContactsResponse>(
    `/campaigns/${campaignId}/contacts/enrich`,
    {
      method: "POST",
      body: body ? JSON.stringify(body) : undefined,
      skipLoading: true,
    }
  );
};

export type TCampaignContactChatMessage = {
  role: "user" | "assistant" | "system";
  content: string;
};

export type TCampaignContactChatRequest = {
  messages: TCampaignContactChatMessage[];
  lp_url?: string;
  /** Nova a cada abertura do chat de teste; isola memória do agente entre execuções. */
  session_id?: string;
};

export type TCampaignContactChatResponse = {
  content: string;
};

export const postCampaignContactChat = async (
  campaignId: string,
  contactId: string,
  body: TCampaignContactChatRequest
): Promise<TCampaignContactChatResponse> => {
  return customFetch<TCampaignContactChatResponse>(
    `/campaigns/${campaignId}/contacts/${contactId}/chat`,
    {
      method: "POST",
      body: JSON.stringify(body),
      skipLoading: true,
    }
  );
};
